import { getLeaveBalancesOfUser } from "@/api/leave-balances";

import { LeaveBalanceDTO } from "@/models/leave-balances.model";
import { User } from "@/models/user.model";
import React, { useEffect, useState } from "react";

import { getUser } from "@/api/users";

import { useCurrentUser } from "@/context/UserContext";
import Card from "@/components/Card";
import { Button } from "@/components/ui/button";
import { ChevronLeft } from "lucide-react";
import BasicInfo from "@/admin/users-page/indiv-user-page/BasicInfo";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import StaffInfoTab from "@/admin/users-page/indiv-user-page/StaffInfoTab";
import EmploymentInfoTab from "@/admin/users-page/indiv-user-page/EmploymentInfoTab";
import PaymentInfoTab from "@/admin/users-page/indiv-user-page/PaymentInfoTab";
import LeaveAllowanceTab from "@/admin/users-page/indiv-user-page/LeaveAllowanceTab";
import IndivStaffPageSkeleton from "@/components/skeletons/IndivPageSkeleton";
import LeaveBalanceCard from "@/components/leave-balance/LeaveBalanceCard";
import StaffLeaveRequestCard from "@/components/leave-request/staff-personal-table/StaffLeaveRequestCard";
import { LeaveRequestDTO } from "@/models/leave-requests.model";
import { toast } from "@/hooks/use-toast";

// set leave balances for user
function ProfilePage() {
  const { currentUser } = useCurrentUser();
  console.log(currentUser);
  // if (!userFetched) {
  //   return <div>Loading...</div>;
  // }
  const [user, setUser] = useState<User | null>(currentUser);
  const [leaveBalances, setLeaveBalances] = useState<LeaveBalanceDTO[]>([]);

  useEffect(() => {
    const fetchLeaveBalances = async () => {
      if (!currentUser) return;
      try {
        const data = await getLeaveBalancesOfUser(currentUser.id);
        setLeaveBalances(data);
      } catch (err) {
        console.log(err);
        toast({
          variant: "destructive",
          title: "Failed to fetch leave balances",
          description: "Please try again later",
        })
      }

    };
    fetchLeaveBalances();
  }, [currentUser]);

  // if (!user) return <div>Loading...</div>;
  if (!currentUser || !leaveBalances) return <IndivStaffPageSkeleton />;
  return (
    <div className="flex flex-col h-max w-full p-4 gap-4">
      <Card>
        {/* 'your profile' header */}

        <div className="flex flex-col p-5 gap-3 lg:h-[700px] h-max w-full">
          <div className="flex gap-10 w-full lg:flex-row flex-col h-full">
            {/* basic info */}
            <div className="flex flex-col gap-5 min-w-[200px] lg:w-2/6">
              <BasicInfo user={currentUser} setUser={setUser} />
            </div>

            <Tabs defaultValue="staff-info" className="w-full space-y-4">
              <TabsList className="w-full overflow-auto justify-start">
                <TabsTrigger value="staff-info" className="flex-1">
                  Staff
                </TabsTrigger>
                <TabsTrigger value="employment-info" className="flex-1">
                  Employment
                </TabsTrigger>
                <TabsTrigger value="payment-info" className="flex-1">
                  Payment
                </TabsTrigger>
                <TabsTrigger value="leave-balance" className="flex-1">
                  Leave Allowance
                </TabsTrigger>
              </TabsList>

              <TabsContent value="staff-info" className="mt-4">
                <StaffInfoTab userId={currentUser.id} user={currentUser} />
              </TabsContent>

              <TabsContent value="employment-info" className="mt-4">
                <EmploymentInfoTab userId={currentUser.id} />
              </TabsContent>

              <TabsContent value="payment-info" className="mt-4">
                <PaymentInfoTab userId={currentUser.id} />
              </TabsContent>
              <TabsContent value="leave-balance" className="mt-4">
                <LeaveAllowanceTab
                  userId={currentUser.id}
                  leaveBalances={leaveBalances}
                  setLeaveBalances={setLeaveBalances}
                />
              </TabsContent>
            </Tabs>
          </div>
        </div>
      </Card>
      <div className="flex w-full gap-5 pb-5 lg:flex-row flex-col">
        <div className="overflow-auto flex-grow">

          <StaffLeaveRequestCard />
        </div>
        <div className="overflow-auto flex-grow">

          <LeaveBalanceCard userId={currentUser.id} />
        </div>
      </div>
    </div>
  );
}

export default ProfilePage;
